<div class="inner-content flex justify-center">
  <div class="container flex flex-1 flex-col items-center gap-10 p-8">
    <div class="flex flex-col items-center justify-center gap-5">
      <ion-icon *ngIf="headerIconSrc" class="header-icon" [src]="headerIconSrc"></ion-icon>
      <span class="text">{{ text }}</span>
      <span class="subtext">{{ subtext }}</span>
    </div>
    <div class="w-100 flex flex-col gap-4 sm:flex-row">
      <ion-button class="flex-1" color="medium-dark" fill="outline" (click)="cancel()">Cancelar</ion-button>
      <ion-button *ngIf="!deleting" class="flex-1" (click)="submit()">Aceptar</ion-button>
      <ion-button *ngIf="deleting" class="flex-1" color="danger" (click)="submit()">
        <ion-icon src="assets/icon/eliminar.svg" class="mr-2.5"></ion-icon>
        Eliminar ahora
      </ion-button>
    </div>
  </div>
</div>
